import { defineComponent as _defineComponent } from 'vue'
import { type Ref, computed, ref, toRefs, useRoute, useRouter, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useCategories } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { getLtksStore } from "@/store/ltks";
import { type LtkHashtag } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkCaption',
  props: {
  ltkId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const { ltkId } = toRefs(props);

const store = useStore();
const amplitude = useAmplitude();
const route = useRoute();
const { supportedHashtags } = useCategories();
const hashtags: Ref<LtkHashtag[]> = ref([]);
const router = useRouter();

const ltk = computed(() => getLtksStore(store).ltks[ltkId.value]);

const caption = computed(() =>
  ltk
    ? {
        caption:
          (hashtags.value = []) &&
          (ltk.value?.caption || "").replace(
            new RegExp(`(#(${supportedHashtags.value.join("|")})\\b)`, "gi"),
            // 1: whole match, 2: hashtag name without octothorpe
            (_match, p1, p2) =>
              (hashtags.value.push({
                to: `/categories/${p2}`,
                text: p1,
              }) &&
                0) ||
              "",
          ),
        hashtags: hashtags.value,
      }
    : {},
);

const hashtagClick = (to: string) => {
  getAmplitudeStore(store).setReferringComponent(
    amplitude?.getReferringComponentByPage(route.value.name ?? "", "hashtag") ?? "",
  );
  router.push(to);
};

return { __sfc: true,props, ltkId, store, amplitude, route, supportedHashtags, hashtags, router, ltk, caption, hashtagClick }
}

})